import React from 'react';
import config from "../../../../../../../config";
import Translate from "../../../../../../../components/Translate";
import PropTypes from "prop-types";
import MemberStatus from "./MemberStatus";
import ColorIndicator from "../../../../../../../components-new/general/ColorIndicator";
import DropdownSelect from "../../../../../../../components-new/form/DropdownSelect";


const statusesToShow = config.currentStatuses
const statusesToShowTranslated = statusesToShow.map(s => {
    return {
        id: s.id,
        name: s.name,
        value: s.value,
        title: <Translate text={s.name.toLowerCase()}/>
    };
});

const MemberCustomStatus = ({member, updateCurrentStatus}) => {
    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <DropdownSelect
                overlay
                options={statusesToShowTranslated}
                selectedValue={member.currentStatus ? member.currentStatus : config.currentStatusMap.offline}
                onChange={(val) => updateCurrentStatus(val.value)}
                variant='outline'
                renderIndicator={(value) => (
                    <div style={{marginLeft: '10px'}}>
                        <ColorIndicator currentStatus={value}/>
                    </div>
                )}
                renderLabel={
                    (val) => typeof val === 'string' ?
                        <Translate text={val}/>
                        :
                        val.title
                }
                styles={{color: 'var(--ds-text-primary)'}}
            >
                {option => (
                    <span style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                        <ColorIndicator currentStatus={option.value}/>
                        <span>{option.title}</span>
                    </span>
                )}
            </DropdownSelect>
        </div>
    );
};

MemberStatus.propTypes = {
    member: PropTypes.object.isRequired,
    updateStatus: PropTypes.func.isRequired,
};

export default MemberCustomStatus;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeesTable/partials/MemberCustomStatus.jsx